export default "<a ng-click=\"$ctrl.logout($ctrl.user)\">logout</a>";